module.exports = __webpack_public_path__ + "assets/img/logo2.dc367890.png";